module.exports = __webpack_public_path__ + "img/lyrica prismriver_lw.227918da.png";